import * as React from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Grid, IconButton, TextField } from "@mui/material";
import { Search } from "@mui/icons-material";
import SellList from "../SellList";
import Success from "components/Success";
import { useNavigate } from "react-router";
import { enquiryLeadsApi } from "store/api";
import Details from "../Details";

function TabPanel (props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps (index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function SellTab () {
  const navigate = useNavigate();
  const [msg, setMsg] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [openView, setOpenView] = React.useState(false);
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const [queryDetails, setQueryDetails] = React.useState({});

  const handleClickOpenView = data => {
    setQueryDetails(data);
    setOpenView(true);
  };
  const handleCloseView = data => {
    setOpenView(false);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [debounceTimeout, setDebounceTimeout] = React.useState(null);

  const [customBattery, setCustomBattery] = React.useState([]);

  // Fetch API results
  const FetchCustomBattery = async searchTerm => {
    const params = !searchTerm
      ? {}
      : {
          keyword: searchTerm,
        };
    try {
      const response = await enquiryLeadsApi(params);
      if (response?.success) {
        setCustomBattery(response?.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleChangeCustom = async e => {
    const { value } = e.target;
    if (debounceTimeout) clearTimeout(debounceTimeout);
    const newTimeout = setTimeout(() => {
      FetchCustomBattery(value);
    }, 500);
    setDebounceTimeout(newTimeout);
  };

  React.useEffect(() => {
    FetchCustomBattery();
  }, []);

  return (
    <div
      style={{
        padding: "20px",
        marginTop: "20px",
        marginBottom: "30px",
        backgroundColor: "",
        border: "",
        borderRadius: "12px",
        boxShadow: "0 0 8px 1px rgba(0,0,0,0.25)",
        color: "",
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <Typography variant='h5' onClick={() => navigate("/custom-battery")}>
          Custom Battery Query
        </Typography>
        <TextField
          placeholder='Search here...'
          InputProps={{
            endAdornment: (
              <IconButton color='inherit'>
                <Search />
              </IconButton>
            ),
          }}
          onChange={handleChangeCustom}
          style={{ backgroundColor: "", borderRadius: "4px" }}
        />
      </div>

      <Box>
        <AppBar position='static'>
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor='secondary'
            textColor='inherit'
            variant='fullWidth'
            aria-label='full width tabs example'
          >
            <Tab label='All' {...a11yProps(0)} />
            {/* <Tab label='Active' {...a11yProps(1)} />
            <Tab label='Pending' {...a11yProps(2)} />
            <Tab label='Restricted' {...a11yProps(3)} />
            <Tab label='Banned' {...a11yProps(4)} /> */}
          </Tabs>
        </AppBar>
        <TabPanel value={value} index={0} dir={theme.direction}>
          <Grid container py={3} spacing={3}>
            {customBattery?.length == 0 && <div>No Custom Battery Found</div>}
            {customBattery?.length > 0 && (
              <SellList
                customBattery={customBattery}
                active={0}
                handleClickOpenView={handleClickOpenView}
              />
            )}
          </Grid>
        </TabPanel>
        {/* <TabPanel value={value} index={1} dir={theme.direction}>
          <Grid container py={3} spacing={3}>
            {customBattery?.length == 0 && <div>No Custom Battery found</div>}
            {customBattery?.length > 0 && (
              <SellList
                customBattery={customBattery}
                active={1}
                handleClickOpenUpdate={handleClickOpenUpdate}
              />
            )}
          </Grid>
        </TabPanel>
        <TabPanel value={value} index={2} dir={theme.direction}>
          <Grid container py={3} spacing={3}>
            {customBattery?.length == 0 && <div>No Custom Battery found</div>}
            {customBattery?.length > 0 && (
              <SellList
                customBattery={customBattery}
                active={2}
                handleClickOpenUpdate={handleClickOpenUpdate}
              />
            )}
          </Grid>
        </TabPanel>
        <TabPanel value={value} index={3} dir={theme.direction}>
          <Grid container py={3} spacing={3}>
            {customBattery?.length == 0 && <div>No Custom Battery found</div>}
            {customBattery?.length > 0 && (
              <SellList
                customBattery={customBattery}
                active={3}
                handleClickOpenUpdate={handleClickOpenUpdate}
              />
            )}
          </Grid>
        </TabPanel>
        <TabPanel value={value} index={4} dir={theme.direction}>
          <Grid container py={3} spacing={3}>
            {customBattery?.length == 0 && <div>No Custom Battery found</div>}
            {customBattery?.length > 0 && (
              <SellList
                customBattery={customBattery}
                active={4}
                handleClickOpenUpdate={handleClickOpenUpdate}
              />
            )}
          </Grid>
        </TabPanel> */}
      </Box>
      <Details open={openView} queryDetails={queryDetails} handleClose={handleCloseView} />
      <Success open={open} success={success} msg={msg} handleClose={handleClose} />
    </div>
  );
}
